import { createSelector } from "reselect";
import { equals } from '../filters/filterUtils';
const getSearch = state => state.search;
const getRouter = state => state.router;
export const getQuery = state => getSearch(state).query;


export const getFilterValues = state => getQuery(state).filters;

export const getFilterLookup = state =>
  getFilterValues(state).reduce((obj, { key, value }) => {
    obj[key] = (obj[key] || []).concat(value);
    return obj;
  }, {});

export const getLocation = state => getRouter(state).location;
export const getRoute = state => getSearch(state).route || null;



export const getInitialQuery = state => getSearch(state).initialQuery;

export const getSelectedSearchOptionKey = state => getSearch(state).searchOption;

export const getCurrentPage = state => getQuery(state).page || 1;

export const getSearchSettings = createSelector(
  getSearch,
  search => search.settings || {},
);

export const getSortBy = createSelector(
  getQuery,
  query => query.sortBy || {},
);

export const getSortByValue = createSelector(
  getSortBy,
  sortBy => sortBy.value || null,
);

export const isFilterValueSelected = state => (key, value) =>
  getFilterValues(state).some(f => f.key === key && equals(f.value, value));

export const isFilterSelected = state => key => getFilterValues(state).some(f => f.key === key);

export const getFilterValue = state => key =>
  isFilterSelected(state)(key) ? getFilterLookup(state)[key][0] : null;

export const getSearchUsageType = createSelector(
    getSearch,
    search => search.settings.usageType || 'PCH',
  );
